const _defaultState = () => ({
    tenants: null,
});

const state = _defaultState();

const mutations = {
    SET_TENANTS(state, tenants) {
        state.tenants = tenants;
    },
    RESET_ADMIN_TENANTS_STATE(state) {
        Object.assign(state, _defaultState());
    },
};

const getters = {
    get_tenants(state) {
        return state.tenants;
    },
    get_tenants_count(state) {
        return state.tenants ? state.tenants.length : null;
    },
    get_collection_points_count(state) {
        if (!state.tenants) return null;
        return state.tenants.reduce((sum, t) => sum + (t.collection_points?.length ?? 0), 0);
    },
};

const actions = {
    async fetchTenants({ commit, rootGetters }) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.listTenants(access_token);
        if (!response.status) throw response.error;

        commit('SET_TENANTS', response.data);
        return response.data;
    },

    async createTenant({ dispatch, rootGetters }, payload) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.createTenant(access_token, payload);
        if (!response.status) throw response.error;

        await dispatch('fetchTenants');
        return response;
    },

    // cadastro direto, sem confirmação de e-mail
    async createClientForTenant({ rootGetters }, { tenant_id, ...data }) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.createClientForTenant(access_token, tenant_id, data);
        if (!response.status) throw response.error;

        return response;
    },

    // etapa 1: dispara o código de verificação para o e-mail informado
    async requestClientCode({ rootGetters }, { email, first_name }) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.createClient(access_token, { email, first_name });
        if (!response.status) throw response.error;

        return response;
    },

    // etapa 2: valida o código e cria a conta
    async createClientWithCode({ rootGetters }, payload) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.createClient(access_token, payload);
        if (!response.status) throw response.error;

        // o back responde 200 (em vez de 201) quando reenvia o código em vez de
        // criar a conta — nesse caso o código não foi aceito
        if (response.message?.includes('verification code sent') ||
            response.message?.includes('code already sent')) {
            throw 'O código informado não foi aceito. Confira o e-mail e tente novamente.';
        }

        return response;
    },
};

const admins_tenants = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};

export default admins_tenants;
